// extracted by mini-css-extract-plugin
module.exports = {"footer":"ShiftCashierHistoryPrintButton_footer__3nvO6"};